import styled, { css } from "styled-components";
import { Link } from "react-scroll";
import { Menu } from "antd";
import { device, sizeConstants } from "../../../globalStyles/breakpoints";

const StickyNavActive = css`
  box-shadow: 0px 7px 15px 0px #00000017;
  color: #000;
`;

export const StickyNav = styled.div`
  position: sticky;
  width: 100%;
  background-color: #f7f9fb;
  border-bottom: 1px solid #f0f0f0;
  border-top: 1px solid #f0f0f0;
  z-index: 1;
  top: 0;
  transition: box-shadow 0.3s;
  border-style: solid;
  border-width: 1px 0px;
  border-color: #e2e2e2 #000;
  &.stuck {
    box-shadow: 0 2px 3px 0 rgba(67, 74, 84, 0.11);
  }
`;

export const StickyDropdown = styled(Menu)`
  position: sticky;
  width: 100%;
  background-color: #f7f9fb;
  border-bottom: 1px solid #f0f0f0;
  border-top: 1px solid #f0f0f0;
  z-index: 1;
  top: 0;
  transition: box-shadow 0.3s;
  border-style: solid;
  border-width: 1px 0px;
  border-color: #e2e2e2 #000;
`;

export const StickyNavContent = styled.div`
  display: flex;
  margin: auto;
  max-width: ${sizeConstants.containerMaxWidth}px;
  width: 100%;
  padding: 0px ${sizeConstants.mobileLRContainerPadding}px;
  height: 56px;
  align-items: center;
  overflow-x: auto;

  ${device.containerMaxWidth} {
    padding: 0;
  }
`;

interface StickyNavItemProps {
  color: string;
}

export const StickyNavItem = styled(Link)`
  padding: 6px 14px 5px;
  line-height: 23px;
  border-radius: 17.5px;
  list-style: none;
  color: #000000;
  display: flex;
  align-items: center;
  margin-right: 12px;
  white-space: nowrap;
  transition: box-shadow 0.2s, color 0.2s, background-color 0.2s;
  :hover {
    color: #000;
    background-color: #fff;
    box-shadow: 0px 7px 15px 0px #00000017;
  }
  &.active {
    ${StickyNavActive}
    background-color: ${(props: StickyNavItemProps) => props.color};
    color: #ffffff;
  }
`;
